var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderOpenRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.498 8.019H15V6.52a1.5 1.5 0 0 0-1.5-1.499h-5l-2-1.998h-5A1.5 1.5 0 0 0 0 4.522v8.991a1.5 1.5 0 0 0 1.5 1.499H14a1.5 1.5 0 0 0 1.272-.705l2.498-3.996c.624-.996-.095-2.292-1.272-2.292zM1.688 4.522h4.19l2 1.998h5.435c.103 0 .187.084.187.187V8.02H4.75a1.5 1.5 0 0 0-1.284.724L1.5 11.997V4.71a.187.187 0 0 1 .188-.187zM14 13.513H2.25l2.414-3.996H16.5L14 13.513z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpenRegular);
export default __webpack_public_path__ + "static/media/folder-open-regular.1feb98d2e4ca3f1a1298dce28dd21079.svg";
export { ForwardRef as ReactComponent };